export enum EnumType {

  PaymentStatusType = "accounting.type.PaymentStatusType",

  ApprovalType = 'finance.itemcatalog.type.ApprovalType',
  ExternalContact = 'externalcontact.type.AbstractExternalContactType',
  CardType = 'tradingpartner.type.CardType',
  PaymentType = 'core.type.PaymentType',
  PaymentTermName = 'tradingpartner.type.PaymentTermName',
  TradingPartnerTxnType = 'tradingpartner.type.PartnerTransactionType',
  AddressType = 'core.type.AddressType',
  TaxPaymentType = 'salestax.type.TaxPaymentType',
  TaxRateType = 'salestax.type.TaxRateType',

  IndustryType = 'core.type.IndustryType',
  OrgContact = 'core.type.ContactType',
  LicenseType = 'core.revenue.type.LicenseType',
  SupportType = 'core.revenue.type.SupportType',
  UsageType = 'core.revenue.type.UsageType',
  OrgBillingPaymentType = 'core.type.PaymentType',
  OrgBillingPlanType = 'core.revenue.type.PlanType',
  Transaction = 'org.atworksys.common.model.Transaction',

  BillingFrequencyType = 'core.type.FrequencyType',
  BillingPlanType = 'billingplan.type.BillingPlanType',
  BillingLevelType = 'contract.type.BillingLevelType',
  BusinessAreaType = 'org.atworksys.entity.core.type.BusinessAreaType',
  ContractBillingStatus = 'contract.type.BilledStatusType',
  ContractBusinessSector = 'contract.type.BusinessSectorType',
  ContractMod = 'contract.type.ModType',
  ContractModImpact = 'contract.type.ModImpactType',
  ContractReportingPeriod = 'contract.type.ReportingPeriodType',
  ContractSlaMetric = 'contract.type.SlaMetricType',
  InternalContact = 'internalcontact.type.AbstractInternalContactType',
  BillingType = 'contract.type.BillingType',
  ClinType = 'contract.type.ClinType',
  ExpenseMarkupType = 'contract.type.ExpenseMarkupType',
  ContractFundingType = 'contract.type.FundingType',
  //Fee Schedule
  FeeScheduleType = 'contractproject.type.FeeScheduleType',
  FeeSubType = 'contractproject.type.FeeSubType',
  FeeMethodType = 'contractproject.type.FeeMethodType',
  // Minimum Schedule
  MinimumScheduleType = 'billingplan.type.MinimumBillingType',

  ChargeableUser = 'core.type.ChargeableUserType',
  Data = 'core.type.DataType',
  Email = 'core.type.EmailType',
  Phone = 'core.type.PhoneType',
  PdfTemplateType = 'pdf.type.PDFTemplateType',
  OrgFileType = 'core.type.OrgFileType',
  User = 'core.type.UserType',

  ChargeCode = 'finance.coa.CodeType',
  ChargeCodeIndirect = 'finance.coa.IndirectType',
  AccountGroup = 'finance.coa.MappingType',
  AccountMapping = 'finance.coa.AccountMappingType',
  Item = 'finance.itemcatalog.type.ItemType',
  FinancialReport = 'finance.report.type.FinancialReportType',
  TimesheetStatus = 'finance.time.type.StatusType',
  TimesheetCycle = 'finance.time.type.CycleType',
  PayCodeType = 'org.atworksys.entity.finance.time.PayCodeType',

  OfferLetter = 'hcm.type.OrgOfferType',
  Clause = 'hcm.type.ClauseType',
  ChargeAuth = 'hcm.ess.type.ChargeAuthType',
  TeamAuth = 'hcm.ess.type.TeamAuthType',
  DepartmentChange = 'hcm.ess.type.DepartmentChangeType',

  Action = 'hcm.recruiting.type.ActionType',
  Account = 'hcm.recruiting.type.AccountType',
  Answer = 'hcm.recruiting.type.AnswerType',
  EducationLevel = 'hcm.recruiting.type.EducationLevelType',
  Gender = 'hcm.recruiting.type.GenderType',
  InterviewAction = 'hcm.recruiting.type.InterviewActionType',
  Location = 'hcm.recruiting.type.LocationType',
  Posting = 'hcm.recruiting.type.PostingType',
  Priority = 'hcm.recruiting.type.PriorityType',
  Question = 'hcm.recruiting.type.QuestionType',
  Salary = 'hcm.recruiting.type.SalaryType',
  Text = 'hcm.recruiting.type.TextType',

  Status = 'hcm.type.StatusType',

  BasicLeave = 'hcm.type.BasicLeaveType',
  Qle = 'hcm.type.QleType',
  ClearanceStatus = 'hcm.type.ClearanceStatusType',
  Contact = 'hcm.type.ContactType',
  Credential = 'hcm.type.CredentialType',
  CredentialStatus = 'hcm.type.CredentialStatusType',
  CycleType = 'finance.time.type.CycleType',
  Dependent = 'hcm.type.DependentType',
  ExtendedLeave = 'hcm.type.ExtendedLeaveType',
  Flsa = 'hcm.type.FlsaType',
  OrgAsset = 'hcm.type.OrgAssetType',
  OrgPolicy = 'hcm.type.OrgPolicyType',
  OrgDocument = 'hcm.type.OrgDocumentType',
  Relationship = 'hcm.type.RelationshipType',
  EmploymentType = 'hcm.type.EmploymentType',
  TaxFormType = 'payroll.type.TaxFormType',

  Currency = 'procurement.purchaserequisition.type.CurrencyType',
  Shipping = 'procurement.purchaserequisition.type.ShippingType',
  SalesOrderStatus = 'org.atworksys.entity.ordermanagement.type.SalesOrderStatus',

  ProjectDueDate = 'project.type.DueDateType',

  JournalType = 'accounting.type.JournalType',
  SourceType = 'accounting.type.SourceType',
  AccountCloseType = 'org.atworksys.entity.finance.coa.AccountingCloseType',
  SystemTaskType = 'org.atworksys.entity.finance.coa.SystemTaskType',

  Entity = 'todotask.type.EntityType',

  //COA Model Options
  ModelSectorType = 'finance.coa.ModelSectorType',
  ModelOptionType = 'finance.coa.ModelOptionType',
  LegalEntityType = 'finance.coa.LegalEntityType',
  PoolAllocationType = 'finance.coa.AllocationType',
  PoolType = 'finance.coa.PoolType',
  IndirectRateType = 'finance.coa.IndirectRateType',
  ExpenseType = 'finance.coa.AccountExpenseType',
  IndirectExpenseType = 'finance.coa.IndirectExpenseType',
  ExpenseCategoryType = 'finance.coa.ExpenseCategoryType',

  OrgModule = 'org.atworksys.common.model.Module',

  FeedBackCategories = 'org.atworksys.common.model.FeedbackCategory',
  PayrollType = 'org.atworksys.entity.payroll.type.PayrollType',
  FilingType = 'org.atworksys.entity.core.type.FilingType',
  PayFrequencyType = 'org.atworksys.manager.payroll.type.PayFrequencyType',
  DeductionMethodType = 'org.atworksys.manager.payroll.type.DeductionMethodType',
  CalendarFrequencyType = 'org.atworksys.entity.core.type.FrequencyType',
  DisbursementType = 'org.atworksys.entity.core.type.DisbursementType',
  WorkLocationType = 'org.atworksys.entity.payroll.type.WorkLocationType',
  AchAllocationType = 'org.atworksys.entity.payroll.type.AchAllocationType',
  PayeeFormType = 'org.atworksys.entity.payroll.type.PayeeFormType',
  TaxFormPDFType = 'org.atworksys.entity.payroll.type.TaxFormPDFType',
  DeductionType = 'org.atworksys.entity.hcm.type.DeductionType',
  PayrollWarningMessage = 'org.atworksys.entity.payroll.PayrollWarningMessage',
  PayrollErrorMessage = 'org.atworksys.entity.payroll.PayrollErrorMessage',

  RoleType =  'org.atworksys.common.model.Role',

  //ACH
  AchBusinessTypes = 'org.atworksys.manager.ach.model.customer.AchBusinessType',
  AchAccountType = 'org.atworksys.manager.ach.model.fundingSource.AchAccountType',
  AchDefaultPaymentType = 'org.atworksys.entity.ach.AchDefaultPaymentType',
  VoucherRegisterTxnType = 'org.atworksys.manager.accounting.model.VoucherRegisterTxnType',

  //Validations
  ValidationCategoryType = 'org.atworksys.validation.solution.ValidationCategoryType',

  //Cyberplan

  CyberplanConfigType = 'org.atworksys.entity.cmmc.type.CyberplanConfigType',
  RiskCategory = 'org.atworksys.entity.cmmc.type.RiskCategory',
  RatingCategory = 'org.atworksys.entity.cmmc.type.RatingCategory',
  MaturityCategory = 'org.atworksys.entity.cmmc.type.MaturityCategory',

  VendorCategory = 'org.atworksys.entity.cmmc.type.VendorCategory',
  SolutionCategory = 'org.atworksys.entity.cmmc.type.SolutionCategory',
  SolutionSizeCategory = 'org.atworksys.entity.cmmc.type.SolutionSizeCategory',

  SecurityRoleCategory = 'org.atworksys.entity.cmmc.type.SecurityRoleCategory',
  ControlOriginationCategory = 'org.atworksys.entity.cmmc.type.ControlOriginationCategory',
  DomainCategory = 'org.atworksys.entity.cmmc.type.DomainCategory',

  ThreatCategory = 'org.atworksys.entity.cmmc.type.ThreatCategory',
  ThreatSourceCategory = 'org.atworksys.entity.cmmc.type.ThreatSourceCategory',
  FrameworkCategory = 'org.atworksys.entity.cmmc.type.FrameworkCategory',
  SystemScope = 'org.atworksys.entity.cmmc.type.SystemScope',
  InfoCategory = 'org.atworksys.entity.cmmc.type.InfoCategory',
  ControlStatusCategory = 'org.atworksys.entity.cmmc.type.ControlStatusCategory',

  SourceCategory = 'org.atworksys.entity.cmmc.type.SourceCategory',

  ImportTemplateType = 'org.atworksys.common.util.excel.ImportTemplateType',
  ImportTemplateSubtype = 'org.atworksys.common.util.excel.ImportTemplateSubtype',

  // Status Type
  ActiveStatus = 'org.atworksys.manager.core.model.ActiveStatus',

  // Benefits
  HealthCoverageType = 'org.atworksys.entity.hcm.type.HealthCoverageType',
  PremiumType = 'org.atworksys.entity.hcm.type.BenefitPremiumType'


}

